import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Quote, ChevronLeft, ChevronRight, Star } from "lucide-react";
import CTAButton from "./CTAButton";
import { useSiteContent } from "../../hooks/useSiteContent";

export default function Testimonials() {
  const { content } = useSiteContent();
  const ts = [
    { n: content.testimonial1_name, role: content.testimonial1_role, q: content.testimonial1_text },
    { n: content.testimonial2_name, role: content.testimonial2_role, q: content.testimonial2_text },
    { n: content.testimonial3_name, role: content.testimonial3_role, q: content.testimonial3_text },
    { n: content.testimonial4_name, role: content.testimonial4_role, q: content.testimonial4_text },
  ];
  const [i, setI] = useState(0);
  useEffect(() => { const t = setInterval(() => setI((p) => (p + 1) % ts.length), 6500); return () => clearInterval(t); }, [ts.length]);
  const go = (d) => setI((p) => (p + d + ts.length) % ts.length);
  return (
    <section className="py-24 lg:py-32 bg-card-gradient relative grain" data-testid="testimonials">
      <div className="container">
        <div className="max-w-3xl mb-14">
          <div className="eyebrow mb-4"><span className="kicker-line" />Resultados reais</div>
          <h2 className="text-4xl md:text-5xl font-display font-light">Palavras de quem <span className="italic text-gold-gradient">confia</span>.</h2>
        </div>
        <div className="relative max-w-4xl mx-auto">
          <Quote className="absolute -top-10 -left-4 text-primary/20" size={120} strokeWidth={1} />
          <div className="relative min-h-[280px]">
            <AnimatePresence mode="wait">
              <motion.div key={i} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }} transition={{ duration: 0.5 }} className="text-center px-4">
                <div className="flex justify-center gap-1 mb-6">{[...Array(5)].map((_, j) => <Star key={j} size={14} className="fill-primary text-primary" />)}</div>
                <p className="font-display text-2xl md:text-3xl font-light leading-relaxed text-foreground mb-8 italic">"{ts[i].q}"</p>
                <div className="text-primary font-display text-lg">{ts[i].n}</div>
                <div className="text-xs uppercase tracking-[0.25em] text-muted-foreground mt-1">{ts[i].role}</div>
              </motion.div>
            </AnimatePresence>
          </div>
          <div className="flex justify-center items-center gap-6 mt-10">
            <button onClick={() => go(-1)} data-testid="testimonial-prev" className="w-11 h-11 rounded-full border border-border hover:border-primary flex items-center justify-center transition-colors"><ChevronLeft size={18} /></button>
            <div className="flex gap-2">{ts.map((_, j) => <button key={j} onClick={() => setI(j)} className={`h-1 rounded-full transition-all ${j === i ? "w-8 bg-primary" : "w-4 bg-border"}`} />)}</div>
            <button onClick={() => go(1)} data-testid="testimonial-next" className="w-11 h-11 rounded-full border border-border hover:border-primary flex items-center justify-center transition-colors"><ChevronRight size={18} /></button>
          </div>
        </div>
        <CTAButton centered />
      </div>
    </section>
  );
}
